module.exports = __webpack_public_path__ + "img/imgSLOGAN-xiaorq.3ffe9dda.png";